export function inWebView(): boolean {
    const userAgent = navigator.userAgent || (navigator as unknown as { vendor?: string }).vendor;
 
    // Check for Android WebView indicators
    const isAndroidWebView = /wv/.test(userAgent) || /WebView/.test(userAgent);
 
    // Check for iOS WebView indicators
    const isIOSWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/.test(userAgent);
 
    return isAndroidWebView || isIOSWebView;
}
